import React from 'react'
import Tools from 'pages/pga-coach/profile/new/form-components/tools'

const EditProfileTools = props => (
  <Tools hideSubheader filledDeleteButton {...props} />
)

export default EditProfileTools
